import { render } from "./TudastarBanner.vue?vue&type=template&id=40f0702c&scoped=true"
import script from "./TudastarBanner.vue?vue&type=script&lang=js"
export * from "./TudastarBanner.vue?vue&type=script&lang=js"

import "./TudastarBanner.vue?vue&type=style&index=0&id=40f0702c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40f0702c"]])

export default __exports__